module.exports = __webpack_public_path__ + "img/MNG52.png";